"use strict";

import toggler from "./helper.toggler";
import openHours from "./helper.openHours";

export default {
    toggler,
    openHours,
};
